import React from 'react';
import { Row } from 'shards-react';
import { withTranslation } from 'react-i18next';
import { ReactComponent as SelectIdeaImageRev } from "../../images/select_category_REV3.svg";

// Import icons
import { ReactComponent as UrgentImage } from '../../images/Icons_Idle_01_Urgent.svg';
import { ReactComponent as ProductivityImage } from "../../images/Icons_Idle_02_Productivity.svg";
import { ReactComponent as CheckmarkImage } from "../../images/Icons_Idle_03_Checkmark.svg";
import { ReactComponent as TrophyImage } from "../../images/Icons_Idle_04_Trophy.svg";
import { ReactComponent as Shield2Image } from "../../images/Icons_Idle_05_Shield.svg";
import { ReactComponent as DollarSignImage } from "../../images/Icons_Idle_06_Dollar Sign.svg";
import { ReactComponent as NumberOneImage } from "../../images/Icons_Idle_07_Number One.svg";
import { ReactComponent as ProblemSolvingImage } from "../../images/Icons_Type_01_Problem Solving_NotSelected.svg";
import { ReactComponent as InnovationImage } from "../../images/Icons_Type_02_Innovation_NotSelected.svg";
import { ReactComponent as ContinuousImprovementImage } from "../../images/Icons_Type_03_ContinuousImprovement_NotSelected.svg";

// Import selected icons
import { ReactComponent as UrgentImageSelected } from '../../images/Icons_Selected_01_Urgent.svg';
import { ReactComponent as ProductivityImageSelected } from "../../images/Icons_Selected_02_Productivity.svg";
import { ReactComponent as CheckmarkImageSelected } from "../../images/Icons_Selected_03_Checkmark.svg";
import { ReactComponent as TrophyImageSelected } from "../../images/Icons_Selected_04_Trophy.svg";
import { ReactComponent as Shield2ImageSelected } from "../../images/Icons_Selected_05_Shield.svg";
import { ReactComponent as DollarSignImageSelected } from "../../images/Icons_Selected_06_Dollar Sign.svg";
import { ReactComponent as NumberOneImageSelected } from "../../images/Icons_Selected_07_Number One.svg";
import { ReactComponent as ProblemSolvingImageSelected } from "../../images/Icons_Type_01_Problem Solving_Selected.svg";
import { ReactComponent as InnovationImageSelected } from "../../images/Icons_Type_02_Innovation_Selected.svg";
import { ReactComponent as ContinuousImprovementImageSelected } from "../../images/Icons_Type_03_ContinuousImprovement_Selected.svg";

const SelectedTypeDisplay = ({ typeItem, typeName, typeDescription, setType, isMobile }) => {
  const getIcon = (name) => {
    const iconWidth = isMobile ? 100 : 200;
    const newIcons = [
      {normal: <UrgentImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <UrgentImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <ProductivityImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <ProductivityImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <CheckmarkImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <CheckmarkImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <TrophyImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <TrophyImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <Shield2Image className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <Shield2ImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <DollarSignImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <DollarSignImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <NumberOneImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <NumberOneImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <ProblemSolvingImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <ProblemSolvingImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <InnovationImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <InnovationImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
      {normal: <ContinuousImprovementImage className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>,
       selected: <ContinuousImprovementImageSelected className="mx-auto d-block" style={{width: iconWidth, height: 'auto'}}/>
      },
    ];

    switch(name) {
      case 'Urgent':
        return newIcons[0].selected;
      case 'Productivity':
        return newIcons[1].selected;
      case 'Checkmark':
        return newIcons[2].selected;
      case 'Trophy':
        return newIcons[3].selected;
      case 'Shield':
        return newIcons[4].selected;
      case 'Dollar':
        return newIcons[5].selected;
      case 'Number One':
        return newIcons[6].selected;
      case 'problem-solving':
        return newIcons[7].selected;
      case 'innovation':
        return newIcons[8].selected;
      case 'continuous-improvement':
        return newIcons[9].selected;
      default:
        return null;
    }
  };

  console.log('typeItem', typeItem, 'typeName', typeName, 'typeDescription', typeDescription)

  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "flex-start", 
      border: "1px solid #E0E0E0", 
      borderRadius: "12px", 
      padding: "12px",
      width: "100%",
      backgroundColor: "#F5F5F5",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)"
    }}>
      {typeItem !== null && typeItem !== undefined ? (
        <Row className={'ml-0'}>
          <div style={{
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'flex-start', 
            gap: '16px', 
            padding: '8px',
            width: '100%'
          }}>
            {getIcon(typeName)}
            <div style={{flex: 1}}>
              <div className="mr-auto" style={{width: '100%'}}>

                <p style={{color: '#303030', textAlign: 'left', fontSize: 14, fontWeight: 600, marginBottom: '4px'}}>{typeName}</p>
                <p style={{ textAlign: 'left', fontSize: 12, fontWeight: 600, fontFamily: 'Helvetica, Arial, sans-serif'}}>{typeDescription}</p>
              </div>
            </div>
          </div>
        </Row>
      ) : (
        <div style={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'flex-start', 
          gap: '16px', 
          padding: '8px',
          width: '100%'
        }}>
          <SelectIdeaImageRev className="d-block" style={{width: 120}} />
          <p style={{ margin: 0, fontWeight: "500", fontSize: "17px", color: "#5A6169" }}>No type selected</p>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(SelectedTypeDisplay); 